import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Section({
  children,
  className,
  ink,
}: {
  children: ReactNode;
  className?: string;
  ink?: boolean;
}) {
  return (
    <section className={cn(ink && "surface-ink", "py-20 md:py-28", className)}>
      <div className="mx-auto max-w-6xl px-5">{children}</div>
    </section>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  center,
  light,
}: {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  center?: boolean;
  light?: boolean;
}) {
  return (
    <div className={cn("max-w-2xl", center && "mx-auto text-center")}>
      {eyebrow && <p className={cn("eyebrow", light ? "text-gold" : "text-muted-foreground")}>{eyebrow}</p>}
      <h2
        className={cn(
          "mt-3 text-3xl md:text-5xl",
          light ? "text-ink-foreground" : "text-foreground",
        )}
      >
        {title}
      </h2>
      <div className={cn("hairline-gold mt-5", center && "mx-auto")} />
      {subtitle && (
        <p className={cn("mt-5 text-base leading-relaxed", light ? "text-ink-foreground/70" : "text-muted-foreground")}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
